export const base = {
  production: true,
  rootUrl: 'https://accounts.pent.com'
};



// WEBPACK FOOTER //
// /builds/pentech-portal/client/src/environments/environment.baseProd.ts